/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneArticleDisclosureLabel as ResolvedStandaloneArticleDisclosureLabel } from 'base/components/standalone/ArticleDisclosureLabel';

export const ArticleDisclosureLabel: typeof ResolvedStandaloneArticleDisclosureLabel = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneArticleDisclosureLabel {...props} />
        </ErrorBoundary>
    );
});

export type ArticleDisclosureLabelProps = PropsFromComponent<typeof ArticleDisclosureLabel>;

/** @deprecated Use slot architecture instead */
export const ArticleDisclosureLabelWith = (extras: DynamicStandaloneExtras): typeof ArticleDisclosureLabel => {
    return function ArticleDisclosureLabel(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleDisclosureLabel');
        return <ResolvedStandaloneArticleDisclosureLabel {...mergeProps({ options: { theme } }, props)} />;
    }
}